// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    MANUFACTURERS_REFRESH_DEVICES_CONFIG_REQUEST,
    MANUFACTURERS_REFRESH_DEVICE_CONFIG_REQUEST,
} from 'Redux/actionTypes';

// Actions
import {
    manufacturersRefreshDevicesConfigResult,
    manufacturersRefreshDeviceConfigResult
} from 'Redux/actions';

// Helpers
import { clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* refreshDevicesConfig({ payload }) {
    try {

        let mutationRefresh = `
        mutation updateVidFleetDevices {
            result: updateVidFleetDevices {
                stepFunctionId
                processStartDate
            }
        }`;

        let data = yield call(
            clientMutation,
            mutationRefresh,
            {},
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(manufacturersRefreshDevicesConfigResult({ refresh: true }))
        }

    } catch (exc) {
        yield put(manufacturersRefreshDevicesConfigResult({ refresh: false }))
        ExceptionManager(
            exc,
            "Manufacturers/.components/refreshDevicesConfig/redux/saga",
            "refreshDevicesConfig"
        )
    }
}

function* refreshDeviceConfig({ payload }) {
    try {
        let { unitId } = payload;
        let mutationRefresh = `
            mutation updateVidFleetDevice ($unitId: Int!) {
                result: updateVidFleetDevice (unitId: $unitId)
            }
        `;

        let data = yield call(
            clientMutation,
            mutationRefresh,
            {
                unitId: unitId
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(manufacturersRefreshDeviceConfigResult({ refresh: true }))
        }

    } catch (exc) {
        yield put(manufacturersRefreshDeviceConfigResult({ refresh: false }))
        ExceptionManager(
            exc,
            "Manufacturers/.components/refreshDeviceConfig/redux/saga",
            "refreshDeviceConfig"
        )
    }
}

function* watchMethods() {
    yield takeEvery(MANUFACTURERS_REFRESH_DEVICES_CONFIG_REQUEST, refreshDevicesConfig);
    yield takeEvery(MANUFACTURERS_REFRESH_DEVICE_CONFIG_REQUEST, refreshDeviceConfig);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}